import { styled } from "@mui/material/styles";
import Snackbar from "@mui/material/Snackbar";
import { LinearProgress } from "@mui/material";

export const ToastStyled = styled(Snackbar)(({ theme }) => ({
  width: "300px",
  minHeight: "45px",
  backgroundColor: "var(--cc-white)",
  boxShadow:
    "0 2px 8px 0 rgba(0, 0, 0, 0.08), 0 -4px 20px 0 rgba(0, 0, 0, 0.08)",
  "& .MuiStack-root": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flex: 1,
    padding: "10px 0",
    gap: "0 8px"
  },
  "& .text-parent": {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    ".meta, .message": {
      color: theme.palette?.FutureTax?.main_80,
      fontWeight: "bold",
      lineHeight: "1.3"
    }
  }
}));

export const StyledLinearProgress = styled(LinearProgress)(
  ({ variant, theme }) => ({
    "& .MuiLinearProgress-bar": {
      width: "200rem",
      backgroundColor: theme.palette[variant || ""]?.main
    },
    "&": {
      backgroundColor: theme.palette?.FutureTax?.main_8
    }
  })
);
